import script from "./BatteryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BatteryComponent.vue?vue&type=script&setup=true&lang=js"

import "./BatteryComponent.vue?vue&type=style&index=0&id=71d3c38b&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/projectivegroup/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d3c38b"]])

export default __exports__